import { FlexRow } from '@editor/components/utilities/layouts';
import ArtboardIcon from '@repo/ui/components/Icon/ArtboardIcon';
import { H6 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

const Text = styled(H6)`
  font-weight: ${themeStyle.fontBold};
  font-size: ${themeStyle.fontSize12};
  line-height: 15px;
`;

export function ArtboardCountBadge(props: {
  count: number;
  className?: string;
}): JSX.Element {
  return (
    <Container className={props.className}>
      <ArtboardIcon height="12px" theme={{ color: themeStyle.backgroundAlt }} />
      <Text color={themeStyle.backgroundAlt}>{props.count}</Text>
    </Container>
  );
}

const Container = styled(FlexRow)`
  justify-content: center;
  align-items: center;
  padding: 2.5px 8px;
  border-radius: 360px;
  gap: 4px;
  background-color: #25282feb;
`;
